const routes = [
  {
    path: '/student/graduation-certification',
    component: () => import('@/views/student/GraduationCertification/Wrapper'),
    children: [
      {
        path: '',
        name: 'graduation-certification',
        component: () =>
          import('@/views/student/GraduationCertification/Main.vue'),
      },
      {
        path: 'add',
        name: 'add-graduation-certification',
        component: () =>
          import(
            '@/views/student/GraduationCertification/AddCertification.vue'
          ),
      },
      {
        path: 'information',
        name: 'graduation-information',
        component: () =>
          import(
            '@/views/student/GraduationCertification/InformationCertification.vue'
          ),
      },
    ],
  },
];

export default routes;
